import Ticket from '../model';
import ModelFactory from '../../model-factory';

export default class Request extends Ticket {
  constructor(data = {}) {
    super(data);
  }
}

export const modelFactory = new ModelFactory('cr', (data) => new Request(data));
